/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { sendErrorEvent } from '@trello/error-reporting';
import {
  LazyTeamOnboardingPupPopover,
  LazyTeamOnboardingPupTooltip,
} from 'app/src/components/BusinessClassTeamOnboardingPupPopover';

export const unmountTeamOnboardingPupPopover = function () {
  if (this.teamOnboardingPupPopoverDiv != null) {
    return ReactDOM.unmountComponentAtNode(this.teamOnboardingPupPopoverDiv);
  }
};

export const unmountTeamOnboardingPupTooltip = function () {
  if (this.teamOnboardingPupTooltipDiv != null) {
    return ReactDOM.unmountComponentAtNode(this.teamOnboardingPupTooltipDiv);
  }
};

export const renderTeamOnboardingPupTooltip = function () {
  if (this.model.viewState.get('showSidebar')) {
    return;
  }

  return setTimeout(() => {
    const tooltip = (
      <LazyTeamOnboardingPupTooltip
        // eslint-disable-next-line react/jsx-no-bind
        onDismiss={() => this.unmountTeamOnboardingPupTooltip()}
      />
    );

    this.teamOnboardingPupTooltipDiv = document.createElement('div');
    $(this.teamOnboardingPupTooltipDiv).insertAfter(
      '.show-sidebar-button-react-root',
    );
    return ReactDOM.render(tooltip, this.teamOnboardingPupTooltipDiv);
  }, 1000);
};

export const renderTeamOnboardingPupPopover = function () {
  try {
    const org = this.model.getOrganization();

    if (org == null) {
      return;
    }

    if (this.teamOnboardingPupPopoverDiv == null) {
      const targetDiv = this.el.querySelector(
        '#team-onboarding-pup-popover-target',
      );

      if (targetDiv != null) {
        this.teamOnboardingPupPopoverDiv = targetDiv;
      } else {
        $('.board-main-content', this.$el).append(
          "<div id='team-onboarding-pup-popover-target'></div>",
        );
        this.teamOnboardingPupPopoverDiv = this.el.querySelector(
          '#team-onboarding-pup-popover-target',
        );
      }
    }

    const boardId = this.model.get('id');

    return renderComponent(
      <LazyTeamOnboardingPupPopover
        orgId={org.id}
        boardId={boardId}
        // eslint-disable-next-line react/jsx-no-bind
        onShowPowerUps={() => this.toggleDirectory()}
        // eslint-disable-next-line react/jsx-no-bind
        onDismissed={() => this.renderTeamOnboardingPupTooltip()}
      />,
      this.teamOnboardingPupPopoverDiv,
    );
  } catch (err) {
    sendErrorEvent(err, {
      tags: {
        ownershipArea: 'trello-mocha',
        feature: 'Team Onboarding',
      },
      extraData: {
        component: 'board-view-team-onboarding-pups',
      },
    });
  }
};
